module.exports = __webpack_public_path__ + "static/logo-franchising-72af9b6a8a9f49f6d91ab9022decb7f7.png";